/**
 * Baybee Custom Header — baybee-header.js
 * Zero dependency on theme header JS.
 */
(function () {
  "use strict";

  var SCROLL_THRESHOLD = 60;

  var glassWrapperEl = document.getElementById("bb-glass-wrapper");
  var solidEl = document.getElementById("bb-solid");
  var annStripEl = document.getElementById("bb-ann-strip");

  if (!solidEl) return;

  // No glass header on non-homepage pages — solid is always visible
  var isHomepage = !!glassWrapperEl;

  var lastScrolled = window.scrollY > SCROLL_THRESHOLD;
  var ticking = false;

  /* ── Position glass below announcement bar ─────────────────── */
  function setGlassTop() {
    var bar = document.querySelector(
      ".announcement-bar, announcement-bar-component, .header-announcements",
    );
    if (bar) {
      var barBottom = bar.offsetTop + bar.offsetHeight;
      document.documentElement.style.setProperty(
        "--bb-glass-top",
        barBottom + 3 + "px",
      );
      document.documentElement.style.setProperty(
        "--bb-solid-top",
        barBottom + "px",
      );
    } else {
      document.documentElement.style.setProperty("--bb-glass-top", "3px");
      document.documentElement.style.setProperty("--bb-solid-top", "0px");
    }
    // Set announcement strip height CSS var for solid header offset
    if (annStripEl) {
      document.documentElement.style.setProperty(
        "--bb-ann-height",
        annStripEl.offsetHeight + "px",
      );
    }
    requestAnimationFrame(setMegaTop);
  }

  /* ── Set solid megamenu top position ───────────────────────── */
  function setMegaTop() {
    // no-op: solid megamenu uses position:absolute top:100%, glass uses fixed positioning
    // kept for glass header scroll state callbacks
  }

  /* ── Scroll swap (homepage only) / slide-up (non-homepage) ─── */
  var isAlwaysVisible = solidEl.classList.contains("bb-solid--always-visible");

  function applyScrollState(scrolled) {
    if (isAlwaysVisible) {
      // Non-homepage: hide announcement strip + slide solid header to top on scroll
      if (scrolled) {
        if (annStripEl) annStripEl.classList.add("bb-hide");
        solidEl.classList.add("bb-solid--scrolled");
      } else {
        if (annStripEl) annStripEl.classList.remove("bb-hide");
        solidEl.classList.remove("bb-solid--scrolled");
      }
      setTimeout(setMegaTop, 260);
      return;
    }
    // Homepage: swap glass ↔ solid
    if (scrolled) {
      glassWrapperEl.classList.add("bb-hide");
      solidEl.classList.add("bb-show");
    } else {
      glassWrapperEl.classList.remove("bb-hide");
      solidEl.classList.remove("bb-show");
    }
    setTimeout(setMegaTop, 350);
  }

  /* ── Init ───────────────────────────────────────────────────── */
  setGlassTop();
  applyScrollState(lastScrolled);

  /* ── Fallback announcement rotation for pages where the module isn't loaded ── */
  (function initAnnouncementFallback() {
    if (
      typeof customElements !== "undefined" &&
      customElements.get &&
      customElements.get("announcement-bar-component")
    )
      return;

    var fallbackIntervals = new Map();

    function clearAllFallbacks() {
      fallbackIntervals.forEach(function (id) {
        clearInterval(id);
      });
      fallbackIntervals.clear();
    }

    function startFallbackFor(container) {
      if (!container) return;
      if (fallbackIntervals.has(container)) return;

      var slides = container.querySelectorAll(".announcement-bar__slide");
      if (!slides || slides.length <= 1) return;

      var current = 0;
      slides.forEach(function (s, i) {
        s.setAttribute("aria-hidden", i !== 0 ? "true" : "false");
      });

      // default to 5s if not specified
      var intervalMs = 5000;

      // look for a nearby slider element with an autoplay attribute (header-announcements usage)
      var sliderEl =
        container.closest(".announcement-bar__slider") ||
        container.querySelector(".announcement-bar__slider");
      if (sliderEl && sliderEl.getAttribute) {
        var attr = sliderEl.getAttribute("autoplay");
        var parsed = parseInt(attr, 10);
        if (!Number.isNaN(parsed) && parsed > 0) intervalMs = parsed * 1000;
      }

      var suspended = false;
      function advance() {
        if (suspended || document.hidden) return;
        current = (current + 1) % slides.length;
        slides.forEach(function (s, i) {
          s.setAttribute("aria-hidden", i !== current ? "true" : "false");
        });
      }

      var id = setInterval(advance, intervalMs);
      fallbackIntervals.set(container, id);

      container.addEventListener("mouseenter", function () {
        suspended = true;
      });
      container.addEventListener("mouseleave", function () {
        suspended = false;
      });
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) suspended = true;
        else suspended = false;
      });
    }

    // scan for possible slide containers
    function scanAndStart() {
      clearAllFallbacks();
      var containers = Array.from(
        document.querySelectorAll(
          ".announcement-bar__slides, .announcement-bar__inner",
        ),
      );
      containers.forEach(function (c) {
        startFallbackFor(c);
      });
    }

    // initial scan + on resize (debounced)
    scanAndStart();
    var _t;
    window.addEventListener(
      "resize",
      function () {
        clearTimeout(_t);
        _t = setTimeout(scanAndStart, 150);
      },
      { passive: true },
    );
  })();

  // Debounced resize — prevents layout thrashing on every resize event
  var resizeTimer;
  window.addEventListener(
    "resize",
    function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setGlassTop, 150);
    },
    { passive: true },
  );

  // HEADER FIX 5 — replaced setTimeout(setGlassTop, 300) with requestAnimationFrame.
  // setTimeout caused a 300ms window where glass header position could be wrong.
  // rAF fires after the browser has completed layout, giving the correct offsetHeight immediately.
  requestAnimationFrame(function () {
    requestAnimationFrame(setGlassTop); // double-rAF ensures paint + layout are both settled
  });

  window.addEventListener(
    "scroll",
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrolled = window.scrollY > SCROLL_THRESHOLD;
        if (scrolled !== lastScrolled) {
          lastScrolled = scrolled;
          applyScrollState(scrolled);
        }
        ticking = false;
      });
    },
    { passive: true },
  );

  /* ── Glass megamenu hover (JS-driven to avoid full-width blocking) ── */
  var activeItem = null;
  var closeTimer = null;

  function openMega(item) {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (activeItem && activeItem !== item) {
      var prevMega = activeItem.querySelector(".bb-mega");
      if (prevMega) prevMega.classList.remove("bb-mega--open");
    }
    activeItem = item;
    var mega = item.querySelector(".bb-mega");
    if (mega) mega.classList.add("bb-mega--open");
  }

  function closeMega() {
    closeTimer = setTimeout(function () {
      if (activeItem) {
        var mega = activeItem.querySelector(".bb-mega");
        if (mega) mega.classList.remove("bb-mega--open");
        activeItem = null;
      }
    }, 120);
  }

  function bindMegaHover(container) {
    container.querySelectorAll(".bb-nav__item").forEach(function (item) {
      if (!item.querySelector(".bb-mega")) return;
      item.addEventListener("mouseenter", function () {
        openMega(item);
      });
      item.addEventListener("mouseleave", closeMega);
      var mega = item.querySelector(".bb-mega");
      if (mega) {
        mega.addEventListener("mouseenter", function () {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        });
        mega.addEventListener("mouseleave", closeMega);
      }
    });
  }

  if (glassWrapperEl) bindMegaHover(glassWrapperEl);
  bindMegaHover(solidEl);

  /* ── Cart badge sync ────────────────────────────────────────── */
  function updateCartBadges(count) {
    document.querySelectorAll(".bb-cart-badge").forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count < 100 ? String(count) : "99+";
        badge.classList.remove("bb-hidden");
        badge.classList.add("bb-pop");
        setTimeout(function () {
          badge.classList.remove("bb-pop");
        }, 300);
      } else {
        badge.classList.add("bb-hidden");
      }
    });
  }

  try {
    var stored = sessionStorage.getItem("cart-count");
    if (stored) {
      var parsed = JSON.parse(stored);
      updateCartBadges(parseInt(parsed.value, 10) || 0);
    }
  } catch (_) {}

  document.addEventListener("theme:cart:update", function (e) {
    var count = e.detail && e.detail.data ? e.detail.data.itemCount : 0;
    updateCartBadges(count);
  });

  document.addEventListener("cart:update", function (e) {
    var count =
      (e.detail && e.detail.itemCount) ||
      (e.detail && e.detail.data && e.detail.data.itemCount) ||
      0;
    updateCartBadges(count);
  });

  /* ── Cart drawer open ───────────────────────────────────────── */
  function openCartDrawer() {
    if (window.__baybeeLoadCartDrawerModule) {
      window.__baybeeLoadCartDrawerModule();
    }

    var fallbackTimer = window.setTimeout(function () {
      var d = document.querySelector(".cart-drawer__dialog");
      if (d && typeof d.showModal === "function" && !d.open) {
        d.showModal();
        return;
      }
      if (!d) {
        window.location.href = "/cart";
      }
    }, 800);

    customElements
      .whenDefined("cart-drawer-component")
      .then(function () {
        window.clearTimeout(fallbackTimer);
        var cd = document.querySelector("cart-drawer-component");
        if (cd && typeof cd.open === "function") {
          cd.open();
          return;
        }
        if (cd && typeof cd.showDialog === "function") {
          cd.showDialog();
          return;
        }
        var d = document.querySelector(".cart-drawer__dialog");
        if (d && typeof d.showModal === "function") {
          d.showModal();
          return;
        }
        window.location.href = "/cart";
      })
      .catch(function () {
        window.clearTimeout(fallbackTimer);
        window.location.href = "/cart";
      });
  }

  // Belt-and-suspenders delegation (inline onclick on buttons is primary)
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest(".bb-cart-trigger")) {
        openCartDrawer();
      }
    },
    true,
  );

  /* ── Search modal open ──────────────────────────────────────── */
  function openSearchModal() {
    var searchModal = document.getElementById("search-modal");
    if (!searchModal) return;
    if (typeof searchModal.showDialog === "function") {
      searchModal.showDialog();
      return;
    }
    if (typeof searchModal.openDialog === "function") {
      searchModal.openDialog();
      return;
    }
    var dialog = searchModal.querySelector("dialog");
    if (dialog && typeof dialog.showModal === "function") {
      dialog.showModal();
    }
  }

  // Event delegation — capture phase, works for both glass and solid header
  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest(".bb-search-trigger")) {
        e.preventDefault();
        e.stopPropagation();
        openSearchModal();
      }
    },
    true,
  ); // capture phase

  /* ── Mobile hamburger → bb-mobile-drawer ───────────────────── */
  var mobileDrawer = document.getElementById("bb-mobile-drawer");
  var drawerOverlay = document.getElementById("bb-drawer-overlay");
  var drawerClose = document.getElementById("bb-drawer-close");

  function openDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add("is-open");
    mobileDrawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("bb-scroll-lock");
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove("is-open");
    mobileDrawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bb-scroll-lock");
  }

  document.querySelectorAll(".bb-hamburger").forEach(function (btn) {
    btn.addEventListener("click", openDrawer);
  });

  if (drawerOverlay) drawerOverlay.addEventListener("click", closeDrawer);
  if (drawerClose) drawerClose.addEventListener("click", closeDrawer);

  // Accordion sub-menus inside drawer
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".bb-mobile-drawer__link--parent");
    if (!btn) return;
    var isExpanded = btn.getAttribute("aria-expanded") === "true";
    // Close all others
    document
      .querySelectorAll(".bb-mobile-drawer__link--parent")
      .forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        var sub = b
          .closest(".bb-mobile-drawer__item")
          .querySelector(".bb-mobile-drawer__sub");
        if (sub) sub.classList.remove("is-open");
      });
    // Toggle clicked
    if (!isExpanded) {
      btn.setAttribute("aria-expanded", "true");
      var sub = btn
        .closest(".bb-mobile-drawer__item")
        .querySelector(".bb-mobile-drawer__sub");
      if (sub) sub.classList.add("is-open");
    }
  });
})();
